__turbopack_context__.v({
  "submitIcon": "SearchInput-module-scss-module__III8Tq__submitIcon",
});
